import {useLocalStorage} from '@aboutyou/storage';
import {GridType} from '@aboutyou/ui-components';
import {useProductImageType} from '../../shared-deprecated/useProductImageType';

const GRID_TYPE_KEY = 'tadarida.preferredGridType:v1';

export const useProductStreamDisplayState = () => {
  const [gridType, updateGridType] = useLocalStorage<GridType>({
    key: GRID_TYPE_KEY,
    defaultValue: 'multi',
  });
  const [productImageType, updateProductImageType] = useProductImageType();

  return {
    gridType,
    columnCount: gridType === 'single' ? 1 : 2,
    productImageType,
    updateGridType,
    updateProductImageType,
  };
};
